import {
  DebitFreezeRequest,
  DebitFreezeResponse,
} from "@services/models/Balances/DebitFreezeModel";
import {
  GetBalanceResponse,
  GetBalancesRequest,
} from "@services/models/Balances/GetBalanceModel";
import { createApiClient } from "../api/createApiClient";
import { AxiosInstance } from "axios";

class BalancesApiService {
  private api: AxiosInstance;
  constructor() {
    this.api = createApiClient();
  }

  public async getBalances(
    data: GetBalancesRequest
  ): Promise<GetBalanceResponse> {
    try {
      const response = await this.api.get("/adminPanel/getBalances", {
        params: {
          page: data.page,
          rows: data.rows,
          search: data.search,
          forMerchant: data.forMerchant,
          userAccountType: data.userAccountType,
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async debitFreezeAccount(
    data: DebitFreezeRequest
  ): Promise<DebitFreezeResponse> {
    try {
      const response = await this.api.post("/adminPanel/debitFreezeAccount", {
        userId: data.userId,
        merchantId: data.merchantId,
        freeze: data.freeze,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export const balanceApis = new BalancesApiService();
